import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import i18n from './locales/index.js'
import './assets/global.css'
// import VConsole from 'vconsole'

// // 移动端调试（只要不是 false 就启用）
// if (import.meta.env.VITE_DEBUG && import.meta.env.VITE_DEBUG !== 'false') {
//   new VConsole()
// }

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
